<template>
  <v-container>
    <v-layout>
      <v-flex md8>
        <p>change password</p>
      </v-flex>
    </v-layout>
    <v-snackbar
      color="success"
      :timeout="5000"
      :bottom="true"
      v-model="success"
    >
      Пароль изменен.
      <v-btn flat icon @click.native="success = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'ChangePassword',
  data () {
    return {
      success: false
    }
  },
  computed: {},
  methods: {
  },
  async mounted () {
  }
}
</script>

<style scoped>

</style>
